import type { ReactNode } from "react";
import style from "./style.module.css";

import {
  CalendarBlank,
  MapPinSimpleArea,
  CaretDown,
  Bus,
  Suitcase,
  TrainSimple,
  Airplane,
  Buildings,
  Money,
  TelegramLogo,
  FacebookLogo,
  TwitterLogo,
  InstagramLogo,
  YoutubeLogo,
  LinkedinLogo,
  Checks,
  Users,
  Wallet,
  Ticket,
  User,
  Phone,
  UsersThree,
  UsersFour,
  Building,
  Bed,
  TrafficCone,
  Camera,
  CarProfile,
  Drop,
  Wind,
  WifiHigh,
  CashRegister,
  Copy,
  Printer,
  SwimmingPool,
  Barbell,
  TennisBall,
  GameController,
  Coffee,
  Taxi,
  Television,
  ChatText,
  Baseball,
  Footprints,
  Elevator,
  PhoneTransfer,
  Backpack,
  FilmReel,
  ImageSquare,
  CheckCircle,
  Sun,
  Scissors,
  Newspaper,
  Car,
  PintGlass,
  House,
  Ambulance,
  WashingMachine,
  Book,
  Clock,
  Bathtub,
  Calendar,
  Mountains,
  City,
  MapPinArea,
  Desk,
  HairDryer,
  Lamp,
  GasCan,
  Thermometer,
  Fire,
  Tree,
  LockSimpleOpen,
  Person,
  Hamburger,
  Mosque,
  VideoConference,
  Cigarette,
  Dress,
  Microphone,
  Toilet,
  ToiletPaper,
  Shower,
  Dog,
  Cookie,
  FileAudio,
  CoatHanger,
  Key,
  Power,
  HandSoap,
  Tooth,
  TreePalm,
  Oven,
  ForkKnife,
  Armchair,
  Rows,
  ShirtFolded,
  Needle,
  BookOpen,
  Prohibit,
  ShoppingBag,
  Football,
  FirstAid,
  Alarm,
  Bicycle,
  Garage,
  FireExtinguisher,
  Campfire,
  Fan,
  PingPong,
  Park,
  Bread,
  BowlFood,
  CigaretteSlash,
  Brandy,
  Clipboard,
  SpeakerHifi,
  SolarRoof,
  Bank,
} from "@phosphor-icons/react/dist/ssr";
const tabIcons: {
  [key: string]: ReactNode;
} = {
  airplane: (
    <Airplane
      key={"airplane"}
      size={26}
      className={`${style.icon} rotate-45`}
    />
  ),
  tour: (
    <Suitcase
      key={"airplane"}
      size={26}
      className={`${style.icon} text-background dark:text-foreground`}
    />
  ),
  hotel: (
    <Buildings
      key={"airplane"}
      size={26}
      className={`${style.icon} text-background dark:text-foreground`}
    />
  ),
  train: (
    <TrainSimple key={"airplane"} size={26} className={"fill-background"} />
  ),
  bus: <Bus key={"airplane"} size={26} className={"fill-backgorund"} />,
};

// Flight Tab

const flightTabIcons: {
  [key: string]: ReactNode;
} = {
  origin: <MapPinSimpleArea className="w-5 h-5" />,
  destination: <MapPinSimpleArea className="w-5 h-5" />,
  depart: <CalendarBlank className="w-5 h-5" />,
  return: <CalendarBlank className="w-5 h-5" />,
  passengers: <CaretDown className="w-5 h-5" />,
};

const navDrawerIcons: ReactNode[] = [
  <Airplane key={"Airplane"} className=" w-5 h-5 rotate-45" />,
  <Suitcase key={"Suitcase"} className="w-5 h-5 text-red" />,
  <Buildings key={"Buildings"} className="w-5 h-5 text-red" />,
  <TrainSimple key={"TrainSimple"} className="w-5 h-5 text-red" />,
  <Bus key={"Bus"} className="w-5 h-5 text-red" />,
  <Money key={"Money"} className="w-5 h-5 text-red" />,
];

const FooterSocialmediaIcons: {
  [key: string]: ReactNode;
} = {
  facebook: (
    <FacebookLogo className="w-7 h-7 text-muted-foreground hover:text-foreground transition duration-75 ease-ease-in-out-circ" />
  ),
  twitter: (
    <TwitterLogo className="w-7 h-7 text-muted-foreground hover:text-foreground transition duration-75 ease-ease-in-out-circ" />
  ),
  instagram: (
    <InstagramLogo className="w-7 h-7 text-muted-foreground hover:text-foreground transition duration-75 ease-ease-in-out-circ" />
  ),
  telegram: (
    <TelegramLogo className="w-7 h-7 text-muted-foreground hover:text-foreground transition duration-75 ease-ease-in-out-circ" />
  ),
  youtube: (
    <YoutubeLogo className="w-7 h-7 text-muted-foreground hover:text-foreground transition duration-75 ease-ease-in-out-circ" />
  ),
  linkedin: (
    <LinkedinLogo className="w-7 h-7 text-muted-foreground hover:text-foreground transition duration-75 ease-ease-in-out-circ" />
  ),
};

const FlightStepperIcons: {
  [key: string]: ReactNode;
} = {
  check: <Checks className="w-5 h-5 max-md:w-5 max-md:h-5" />,
  users: <Users className="w-5 h-5 max-md:w-5 max-md:h-5" />,
  wallet: <Wallet className="w-5 h-5 max-md:w-5 max-md:h-5" />,
  voucher: <Ticket className="w-5 h-5 max-md:w-5 max-md:h-5" />,
};

const FlightPassengersIcons: {
  [key: string]: ReactNode;
} = {
  people: <User weight="fill" className="w-5 h-5 text-secondary" />,
  phone: <Phone weight="fill" className="w-5 h-5 text-secondary" />,
};

const hotelRoomCardIcons: {
  [key: string]: ReactNode;
} = {
  "1": <User className="w-5 h-5 text-muted-foreground" />,
  "2": <Users className="w-5 h-5 text-muted-foreground" />,
  "3": <UsersThree className="w-5 h-5 text-muted-foreground" />,
  "4": <UsersFour className="w-6 h-6 text-muted-foreground" />,
};

const hotelStepperIcons: {
  [key: string]: ReactNode;
} = {
  check: <Checks className="w-6 h-6 max-md:w-5 max-md:h-5" />,
  users: <Users className="w-6 h-6 max-md:w-5 max-md:h-5" />,
  wallet: <Wallet className="w-6 h-6 max-md:w-5 max-md:h-5" />,
  voucher: <Ticket className="w-6 h-6 max-md:w-5 max-md:h-5" />,
};

const facilityIcons: {
  [key: string]: ReactNode;
} = {
  "": <ImageSquare className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Number_of_Layers: <Building className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Number_of_Beds: <Bed className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Total_Capacity: <Ticket className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Traffic_Status: <TrafficCone className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Free_Parking: <CarProfile className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Commercial_Store: <Building className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Twenty_four_hours_Reception: (
    <Building className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Free_Mineral_Water: <Drop className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Central_Video_System: <Camera className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Central_Split_Air_Conditioning: (
    <Wind className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  digital_safe_deposit_box: (
    <Checks className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Free_Wireless_Internet: (
    <WifiHigh className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  IP_TV: <Television className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  ATM: <CashRegister className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Photocopy: <Copy className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Fax_and_Photocopy: <Copy className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Printer: <Printer className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Swimming_Pool: <SwimmingPool className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Sauna: <SwimmingPool className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Jacuzzi: <SwimmingPool className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Gym: <Barbell className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Tennis_Court: <TennisBall className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Game_Center: <GameController className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Sports_Field: <Barbell className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Sports_Hall: <Barbell className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Billiards_Room: <Baseball className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Massage: <ChatText className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Travel_Agency: <Park className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Coffee: <Coffee className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Shoe_Shine_Machine: <Footprints className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Taxi_Service: <Taxi className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Luggage_Room: <Backpack className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  safe_deposit_box: <Checks className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Elevator: <Elevator className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Studio: <FilmReel className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Transfer: <PhoneTransfer className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  CIP_Services: <CheckCircle className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Currency_Exchange: <Money className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Internet_Coffee: <Coffee className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Leisure_Tour_Services: <Sun className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Hair_Salon: <Scissors className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Newspaper: <Newspaper className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Car_Rental_Without_Driver: <Car className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Services_for_Disabled: (
    <LockSimpleOpen className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Housekeeping_Services: <House className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Ticketing_Services: <Ticket className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Free_Minibar: (
    <PintGlass weight="bold" className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Laundry_Services: (
    <WashingMachine className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Library: <Book className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Smoking_Room: <Cigarette className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Foreign_Payment: <Money className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Medical_Services: <Ambulance className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Luggage_Services: <Backpack className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Child_Care_Services: <Person className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Traditional_Teahouse: <House className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Fast_Food: <Hamburger className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Bridal_Room: <Dress className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Twenty_four_hour_Hour_Room_Service: (
    <Clock className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Thermal_Water_Therapy: <Drop className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Prayer_Room: <Mosque className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Conference_Hall: (
    <VideoConference className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Water_Complex: <Drop className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Lobby: <Elevator className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Playroom: <Microphone className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Children_Park: <Tree className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Green_Space: <Tree className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Concert_Hall: <Microphone className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Western_style_toilet: <Toilet className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Iranian_style_toilet: (
    <ToiletPaper className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  In_room_service: <HandSoap className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Shower: <Shower className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Bathtub: <Bathtub className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Pet_friendly: <Dog className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Smoking_allowed: <Cigarette className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Cooking_allowed: <Cookie className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Free_internet: <WifiHigh className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Audio_and_video_system: (
    <FileAudio className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Tea_maker: <Coffee className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Clothes_hanger: <CoatHanger className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Telephone: <Phone className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Air_conditioning: <Wind className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Fire_extinguishing_system: <Fire className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Heating_and_cooling_system: (
    <Thermometer className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Room_door_lock: <Key className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Power_switch: <Power className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Gas_stove: <Oven className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Iron: <GasCan className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Kitchen_utensils: <ForkKnife className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Refrigerator: <ForkKnife className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Furniture: <Armchair className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Drawer: <Rows className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Lamp: <Lamp className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Wardrobe: <ShirtFolded className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Cabinet: <Rows className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  hair_dryer: <HairDryer className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Toothbrush: <Tooth className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Toothpaste: <Tooth className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Shampoo: <Shower className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Thread_and_needle: <Needle className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Writing_desk: <Desk className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Indoor_slippers: <Footprints className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Balcony: <House className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Area_size: <MapPinArea className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Window: <House className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  City_view: <City className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Sea_view: <SwimmingPool className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Forest_view: <TreePalm className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Mountain_view: <Mountains className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Lake_view: <SwimmingPool className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Year_of_renovation: <Calendar className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Buffet_menu: <BookOpen className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Turkish_bath: <Bathtub className="w-5 h-5 max-md:w-5 max-md:h-4" />,

  No_pets: <Prohibit className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Twenty_four_hour_hour_service: (
    <Clock className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  No_smoking: <CigaretteSlash className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Airport_reception: <Airplane className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Special_facilities_for_disabled_guests: (
    <Person className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Locked_cabinet: <LockSimpleOpen className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Transfer_services: (
    <PhoneTransfer className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Meeting_and_banquet_facilities: (
    <Users className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Shop: <ShoppingBag className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Prayer_room: <Mosque className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Football_hall: <Football className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Gazebo: <Bank className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  First_aid_kit: <FirstAid className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Wedding_hall: <Brandy className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  WiFi: <WifiHigh className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Wake_up_call_service: <Alarm className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Taxi_service: <Taxi className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Coffee_shop: <Coffee className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Fire_alarm: <Fire className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Meeting_room: <User className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Conference_room: (
    <VideoConference className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  TV: <Television className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Bathroom: <Shower className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Daily_room_service: <Clipboard className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Air_ventilation_system: <Wind className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Western_style_bathroom: <Bathtub className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Iranian_style_bathroom: <Bathtub className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Laundry_services: (
    <WashingMachine className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Shoe_polishing_machine: (
    <Footprints className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Restaurant: <ForkKnife className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Request_for_amenities: (
    <Park weight="light" className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Breakfast: <Bread className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Bicycle: <Bicycle className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Parking: <Garage className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Car_rental: <Car className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Fire_extinguisher: (
    <FireExtinguisher className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Round_trip_service_to_the_shrine: (
    <Campfire className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Evaporative_cooler: <Wind className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Dedicated_play_area_for_children: (
    <Park weight="light" className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Table_football: <BowlFood className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Dining_table: <BowlFood className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Outdoor_space: (
    <Park weight="light" className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Rooftop_garden: <SolarRoof className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Ironing_clothes: <GasCan className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Buffet_breakfast: <Bread className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Childcare_services: <Person className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Coffee_maker: <Coffee className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Ticket_issuance_and_reservation_services: (
    <Ticket className="w-5 h-5 max-md:w-5 max-md:h-4" />
  ),
  Ping_pong: <PingPong className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Radiator: <Fan className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Fan: <Fan className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Sound_system: <SpeakerHifi className="w-5 h-5 max-md:w-5 max-md:h-4" />,
  Gas_heater: <GasCan className="w-5 h-5 max-md:w-5 max-md:h-4" />,
};

export {
  tabIcons,
  flightTabIcons,
  navDrawerIcons,
  FooterSocialmediaIcons,
  FlightStepperIcons,
  FlightPassengersIcons,
  hotelRoomCardIcons,
  hotelStepperIcons,
  facilityIcons,
};
